<template>
  <div>
    <v-container fluid grid-list-md class="padding_10">
      <v-layout row wrap style="padding: 0px 0px 0px 0px; align-content: center; align-items: center;">
        <v-flex xm12 sm12 md12 lg12>
          <v-expansion-panel class="mb-4">
            <v-expansion-panel-content>
              <template v-slot:header>
                <div>Filters</div>
              </template>
              <v-layout row wrap style="padding: 0px 10px 0px 10px; align-content: center; align-items: center;"
                        class="index_header">

                <v-flex sm12 md6 lg4 style="padding-top: 17px;">
                  <v-autocomplete
                      v-model="filters.issue_for"
                      :items="title_list"
                      placeholder="Provider"
                      item-value="value"
                      item-text="text"
                      clearable solo flat
                  ></v-autocomplete>
                </v-flex>

                <v-flex sm12 md6 lg4 style="padding-top: 17px;">
                  <v-autocomplete
                      v-model="filters.issue_status"
                      :items="issue_status"
                      placeholder="Issue Status"
                      item-value="value"
                      item-text="text"
                      clearable solo flat
                  ></v-autocomplete>
                </v-flex>
              </v-layout>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-flex>

        <!--        <v-flex xm12 sm12 md12 lg12 style="display: flex">-->
        <!--          <v-flex xm12 sm12 md6 lg7></v-flex>-->
        <!--                  <v-flex xm12 sm12 md6 lg5 style="display: flex; justify-content: flex-end;">-->
        <!--                    <v-btn primary>-->
        <!--                      <router-link to="" class="white&#45;&#45;text">-->
        <!--                        <v-icon color="#bbbbc6" class="white&#45;&#45;text mr-2">edit-->
        <!--                        </v-icon-->
        <!--                        >-->
        <!--                        Yatri(BPP) Issue-->
        <!--                      </router-link-->
        <!--                      >-->
        <!--                      </v-btn>-->
        <!--                  </v-flex>-->
        <!--        </v-flex>-->

        <v-flex xs12>
          <v-data-table
              no-results-text="Loading... Please wait"
              :headers="headers"
              v-model="selected"
              :items="issue_list"
              item-key="id"
              :loading="loaders.issue_loader"
              :total-items="total_items"
              :rows-per-page-items="[10, 20, 50, 100]"
              class="elevation-1"
              :pagination.sync="pagination"
          >
            <template v-slot:items="props">

              <td class="text-xs-left" v-if="props.item.short_description">
                <router-link :to="{name:'ondcIssueGrievanceDetails', params:{id: props.item.transaction_id}}">
                  {{ props.item.short_description }}
                </router-link>
              </td>

              <td class="text-xs-left" v-if="props.item.long_description">{{ props.item.long_description }}</td>
              <td v-else> {{ " - " }}</td>

              <td class="text-xs-left" v-if="props.item.order_category">{{ props.item.order_category }}</td>
              <td v-else> {{ " - " }}</td>

              <td class="text-xs-left" v-if="props.item.order_sub_category">{{ props.item.order_sub_category }}</td>
              <td v-else> {{ " - " }}</td>

              <td v-if="props.item.issue_status == 'OPEN'">
                <v-chip style="font-size: 12px;"
                         color="#cce0ff" text-color="primary"> {{ props.item.issue_status
                  }}</v-chip>
              </td>
              <td v-else-if="props.item.issue_status == 'CLOSE'"><v-chip style="font-size: 12px;"
                     color="#ffb3b3" text-color="#ff1a1a"> {{ props.item.issue_status }}</v-chip>
              </td>
              <td v-else> {{ " - " }}</td>


              <td class="text-xs-left" v-if="props.item.is_seller_initiated == 1">
                <v-chip color="#e0b3ff" text-color="#8a00e6">{{ "Seller" }} </v-chip></td>
              <td v-else-if="props.item.is_seller_initiated == 0">
                <v-chip color="#99ff99" text-color="#008000"> {{ "User" }} </v-chip></td>

              <td class="text-xs-left" v-if="props.item.issue_action == 'PROCESSING'">
                <v-chip color="#FFEDAA" text-color="#935E0D">{{ props.item.issue_action }}</v-chip></td>
              <td class="text-xs-left" v-if="props.item.issue_action == 'RESOLVED'">
                <v-chip color="#C8E6C9" text-color="#1B5E20">{{ props.item.issue_action }}</v-chip></td>

              <td v-else> {{ " - " }}</td>


            </template>
          </v-data-table>
        </v-flex>
      </v-layout>

      <v-snackbar
          v-model="snackbar.display"
          :color="snackbar.color"
          :top="snackbar.top"
          :bottom="snackbar.bottom"
          :left="snackbar.left"
          :right="snackbar.right"
          :timeout="snackbar.timeout"
      >
        {{ snackbar.message }}
        <v-btn text dark @click="snackbar.display = false">
          <v-icon right color="white"> close</v-icon>
        </v-btn>
      </v-snackbar>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "Index",
  watch: {
    pagination: {
      handler() {
        this.getIssueData();
      },
    },
    "filters.issue_for": function (val) {
      if (val) {
        this.filters.issue_for = val;
        this.getIssueData();
      } else if (val == null || val == undefined) {
        this.filters.issue_for = "";
        this.getIssueData();
      }
    },
    "filters.issue_status": function (val) {
      if (val) {
        this.filters.issue_status = val;
        this.getIssueData();
      } else if (val == null || val == undefined) {
        this.filters.issue_status = "";
        this.getIssueData();
      }
    }
  },
  data() {
    return {
      issue_list: [],
      pagination: {sortBy: "created_at", descending: false, rowsPerPage: 10},
      total_items: 0,
      selected: [],
      loaders: {
        issue_loader: false,
        settlement_loader: false
      },
      headers: [
        {
          text: "Short Desc",
          value: "short_desc",
          sortable: false,
        },
        {
          text: "Desc",
          value: "long_desc",
          sortable: false,
        },
        {
          text: "Order Category",
          value: "order_category",
          sortable: false,
        },
        {
          text: "Sub Category",
          value: "order_sub_category",
          sortable: false,
        },
        {
          text: "Issue Status",
          value: "issue_status",
          sortable: false,
        }, {
          text: "Issue Action",
          value: "issue_action",
          sortable: false,
        },
        {
          text: "Raised By",
          value: "issue_raised_by",
          sortable: false,
        },
        // {
        //   text: "Action",
        //   value: "action",
        //   sortable: false,
        // }
      ],
      updateSettlementDialog: false,
      filters: {
        issue_for: 'ALL',
        issue_status: "ALL",
      },
      title_list: [
        {'text': 'ALL', value: 'ALL'},
        {'text': 'Seller Side', value: 'BPP'},
        {'text': 'Buyer Side', value: 'BAP'}
      ],
      issue_status: [
        {'text': 'ALL', value: 'ALL'},
        {'text': 'OPEN', value: 'OPEN'},
        {'text': 'CLOSE', value: 'CLOSE'}
      ],
      snackbar: {
        message: "",
        display: false,
        color: "black",
        top: true,
        right: true,
        bottom: false,
        left: false,
        timeout: 2000,
      },
    }
  },
  methods: {
    getIssueData() {
      this.startLoading();
      this.pagination.filters = Object.assign({}, this.filters);
      axios.get(`${process.env.VUE_APP_API_URL}/api/v1/get-raised-issue`,
          {headers: this.$headers, params: this.pagination}).then((response) => {
        if (response.data.status == 1) {
          this.stopLoading();
          this.issue_list = response.data.data;
        } else if(response.data.status == 0)  {
          this.stopLoading();
          this.snackbar.message = response.data.message;
          this.snackbar.display = true;
        }
      });
    },
    searchByTitle() {
      this.getIssueData();
    },
  }
}
</script>

<style scoped>

</style>
